/* It's a modal that allows the user to select a group and a point to distribute a form to */
import React, { Component } from "react"
import { Button, Modal, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap"
import EmployeeDataTypes from "src/pages/hr/Types/EmployeeTypes"
import stateMutator from "../Utils/StateMutator"
import DynamicFormTypes from "../Types/DynamicFormsTypes"
import taskDynamicFormBoiler from "../Utils/TaskDynamicFormBoiler"
import TaskDynamicFormTypes from "../Types/TaskDynamicFormTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import TaskDynamicFormOptionsGroup from "./TaskDynamicFormOptions/TaskDynamicFormOptionsGroup/TaskDynamicFormOptionsGroup"
import TaskDynamicFormOptionsPoint from "./TaskDynamicFormOptions/TaskDynamicFormOptionsPoint/TaskDynamicFormOptionsPoint"
import TaskDynamicFormOptionsTable from "./TaskDynamicFormOptions/TaskDynamicFormOptionsTable/TaskDynamicFormsOptionsTable"
import TaskDynamicFormOptionsSearch from "./TaskDynamicFormOptions/TaskDynamicFormOptionsSearch/TaskDynamicFormOptionsSearch"
import taskHelper from "./taskHelper"
import DynamicFormReferenceTypes from "../Types/DynamicFormReferenceTypes"
import DynamicFormTaskTypes from "../Types/DynamicFormTaskTypes"
import TaskDynamicFormDueDatePicker from "./TaskDynamicFormDueDatePicker/TaskDynamicFormDueDatePicker"
import dayjs from "dayjs"
import axios from "axios"
import snackBar from "src/utilities/snackBar/SnackBar"
import AxiosConfig from "src/utilities/AxiosConfig"
import "./TaskDynamicForm.css"
interface Props {
    form: DynamicFormTypes
    manageParentState: Function
    employees: Array<EmployeeDataTypes> | []
    formReference: DynamicFormReferenceTypes
    userId: string | number
    palette: Array<DynamicFormPaletteTypes>
}

interface State {
    busy: boolean
    taskBoiler: TaskDynamicFormTypes
    distributionGroup: Array<{ id: number, text: string }> | []
    distributionGroupCopy: Array<{ id: number, text: string }> | []
    tasks: { taskList: Array<DynamicFormTaskTypes>, checkedTally: {} }
    setDueDate: boolean
}

class TaskDynamicForm extends Component<Props, State> {

    timeFormat = "YYYY/MM/DD"
    required = [
        { key: "DueDateUTC", alias: "Due date missing", type: "string" },
    ]

    state = {
        busy: false,
        taskBoiler: taskDynamicFormBoiler,
        distributionGroup: [],
        distributionGroupCopy: [],
        tasks: { taskList: [], checkedTally: {} },
        setDueDate: false
    }

    componentDidMount() {
        //@ts-ignore
        taskHelper.init(this.props.formReference, this.props.employees)
        //@ts-ignore
        const distributionGroup = taskHelper.getDistributionGroup(taskDynamicFormBoiler.FormDistributeTo).data.normalized
        this.manageState([
            { key: "distributionGroup", value: distributionGroup },
            { key: "distributionGroupCopy", value: JSON.parse(JSON.stringify(distributionGroup)) }
        ])
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    audit = (boiler: TaskDynamicFormTypes) => {
        let issues = []
        const taskCount = this.state.tasks.taskList.length
        const requiredItems = this.required
        for (let i = 0; i < requiredItems.length; i++) {
            const requiredItem = requiredItems[i]
            //@ts-ignore
            if (typeof boiler[requiredItem.key] !== requiredItem.type) {
                issues.push(requiredItem.alias)
            }
        }
        if (taskCount === 0) {
            issues.push("No recipients selected")
        }
        return { canSubmit: ((issues.length === 0) && taskCount > 0), issues: issues, hasDueDate: boiler.DueDateUTC }
    }

    sendTasks = () => {
        //@ts-ignore
        const tasks = taskHelper.buildFinalTasks(this.props.userId, this.props.form.CustomFormId, this.state.taskBoiler)
        this.manageState([{ key: "busy", value: true }])
        axios.post(process.env.REACT_APP_API_URL + "/api/company/SaveDynamicFormTask", { tasks: tasks }, AxiosConfig.configValue("min"))
            .then((res) => {
                // console.log("sendTasks() res", res)
                let errors = 0
                const tasks = res.data.tasks
                for (let i = 0; i < tasks.length; i++) {
                    if (!tasks[i].error.success) {
                        errors++
                        snackBar({ text: `Error: ${tasks[i].error.message}`, type: "error", timeout: 3000 })
                    }
                }
                if (errors === 0) {
                    snackBar({ text: "Tasks succesfully assigned", type: "primary", timeout: 3000 })
                }
                this.manageState([{ key: "busy", value: false }])
                this.props.manageParentState([{ key: "formToTask", value: null }])
            }).catch((/*err: any*/) => {
                //console.log(err)
                snackBar({ text: "Error assigning form tasks", type: "error", timeout: 3000 })
                this.manageState([{ key: "busy", value: false }])
                this.props.manageParentState([{ key: "formToTask", value: null }])
            })
    }

    render() {

        const props = this.props
        const state = this.state
        const taskBoiler = state.taskBoiler
        const taskReference = props.formReference
        const distributionGroup = state.distributionGroup
        const distributionGroupCopy = state.distributionGroupCopy
        const audit = this.audit(taskBoiler)
        const taskOrTasks = `task${state.tasks.taskList.length > 1 ? "s" : ""}`

        const TaskDynamicFormToolTip = (text: string) => (
            <Tooltip id={`task-dynamic-form-tooltip`}>
                {text}
            </Tooltip>
        )

        // console.log("df_form TaskDynamicForm props", props)
        // console.log("df_form TaskDynamicForm state", state)
        // console.log("df_form TaskDynamicForm tasks", state.tasks)
        // console.log("df_form TaskDynamicForm submitStatus", this.audit(taskBoiler), taskBoiler)
        // console.log("df_form TaskDynamicForm taskBoiler", taskBoiler)
        // console.log("df_form TaskDynamicForm distributionGroup", distributionGroup)

        return (
            <div className="TaskDynamicForm" >
                <Modal
                    id={`task-dynamic-form-modal-fade-${state.setDueDate}`}
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size={"lg"}
                >
                    <Modal.Header>
                        <div className={`TaskDynamicFormModalHeader ${state.busy ? "TaskDynamicFormModalHeaderBusy" : "TaskDynamicFormModalHeaderNotBusy"}`}>
                            <div className="TaskDynamicFormModalHeaderLeft">
                                <div className="TaskDynamicFormModalHeaderLeftChooseDistPoint">
                                    {taskReference &&
                                        <TaskDynamicFormOptionsPoint
                                            manageParentState={this.manageState}
                                            taskBoiler={taskBoiler}
                                            DistributionPoints={taskReference.DistributionPoints}
                                        />}
                                </div>
                            </div>
                            <div className="TaskDynamicFormModalHeaderRight">
                                <OverlayTrigger placement="top" overlay={TaskDynamicFormToolTip(props.form.Name)}>
                                    <p>{props.form?.Name}</p>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={`TaskDynamicFormModalBody ${state.busy ? "TaskDynamicFormModalBodyBusy" : "TaskDynamicFormModalBodyNotBusy"}`}>
                            <div className="TaskDynamicFormModalBodyOptionsGroupAndSearch">
                                <div className="TaskDynamicFormModalBodyItem">
                                    {taskReference &&
                                        <TaskDynamicFormOptionsGroup
                                            manageParentState={this.manageState}
                                            taskBoiler={taskBoiler}
                                            DistributionGroups={taskReference.DistributionGroups}
                                            checkedTally={state.tasks.checkedTally}
                                        />}
                                </div>
                                <div className="TaskDynamicFormModalBodyItem">
                                    <TaskDynamicFormOptionsSearch
                                        manageParentState={this.manageState}
                                        distributionGroup={distributionGroup}
                                        distributionGroupCopy={distributionGroupCopy}
                                    />
                                </div>
                            </div>
                            <div className="TaskDynamicFormModalBodyItem TaskDynamicFormModalBodyItemTable ">
                                <TaskDynamicFormOptionsTable
                                    manageParentState={this.manageState}
                                    taskBoiler={taskBoiler}
                                    taskReference={props.formReference}
                                    employees={props.employees}
                                    distributionGroup={distributionGroup}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="TaskDynamicFormModalFooter">
                            {!state.busy && <div className="TaskDynamicFormModalFooterNotBusy">
                                <div className="TaskDynamicFormModalFooterNotBusyLeft">
                                    <div className="TaskDynamicFormModalFooterNotBusyLeftBackBtn">
                                        <Button variant="secondary" onClick={() => props.manageParentState([{ key: "formToTask", value: null }])}>Cancel</Button>
                                    </div>
                                </div>
                                <div className="TaskDynamicFormModalFooterNotBusyRight">
                                    {/*@ts-ignore*/}
                                    {audit.hasDueDate && <p className="TaskDynamicFormModalFooterNotBusyRightDueDateDescriptor">{`Due: ${dayjs(taskBoiler.DueDateUTC).format(this.timeFormat)}`}</p>}
                                    <OverlayTrigger placement="top" overlay={TaskDynamicFormToolTip(`${!audit.hasDueDate ? "Set" : "Change"} due date`)}>
                                        <span
                                            className={`material-icons TaskDynamicFormModalFooterNotBusyToggleDatePicker ${audit.hasDueDate ? "TaskDynamicFormModalFooterNotBusyToggleDatePickerDateSet" : "TaskDynamicFormModalFooterNotBusyToggleDatePickerDateNotSet"}`}
                                            onClick={() => this.manageState([{ key: "setDueDate" }])}>
                                            event
                                        </span>
                                    </OverlayTrigger>
                                    <OverlayTrigger placement="top" overlay={taskHelper.statusPopover(audit.issues)}>
                                        <div className={`TaskDynamicFormModalFooterNotBusySubmitBtn ${audit.canSubmit ? "TaskDynamicFormModalFooterNotBusySubmitBtnEnabled" : "TaskDynamicFormModalFooterNotBusySubmitBtnDisabled"}`}
                                            onClick={audit.canSubmit ? () => this.sendTasks() : () => null}
                                        >
                                            <p>{`Send ${taskOrTasks}`}</p>
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </div>}
                            {state.busy && <div className="TaskDynamicFormModalFooterBusy">
                                <p>Assigning tasks, please wait...</p>
                                <Spinner id="task-dynamic-form-modal-footer-busy-spinner" animation="border" />
                            </div>}
                        </div>
                    </Modal.Footer>
                </Modal>
                {state.setDueDate && <TaskDynamicFormDueDatePicker
                    manageParentState={this.manageState}
                    taskBoiler={taskBoiler}
                />}
            </div >
        )
    }
}

export default TaskDynamicForm